/**
 * TruIntent Funnel API Client
 */

const API_BASE = import.meta.env.VITE_API_BASE || '/api';

/**
 * Fetch funnel data
 */
export async function getFunnel(funnelId) {
  const response = await fetch(`${API_BASE}/funnels/${funnelId}?include_pages=true`);
  if (!response.ok) {
    throw new Error(`Failed to load funnel: ${response.statusText}`);
  }
  const data = await response.json();
  return data.funnel;
}

/**
 * Capture lead
 */
export async function captureLead(funnelId, pageId, ctaId, formData, attribution) {
  const payload = {
    page_id: pageId,
    cta_id: ctaId,
    form_data: formData,
    utm_source: attribution.last_touch.utm_source,
    utm_medium: attribution.last_touch.utm_medium,
    utm_campaign: attribution.last_touch.utm_campaign,
    referrer: attribution.last_touch.referrer,
  };

  const response = await fetch(`${API_BASE}/funnels/${funnelId}/leads`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(error.error || 'Failed to submit form');
  }

  const data = await response.json();
  return data;
}
